export default "__VITE_ASSET__BqhtrbSX__"